/**
 * One titled block in the TOC navigator's read-only detail view: a small
 * heading with its content below, separated from the previous block by a
 * hairline. Not collapsible — the blocks are short since the intelligence
 * sections left the TOC (2026-10-30), and the toggles only added noise.
 *
 * @param {object} props
 * @param {string} props.label - Section heading text
 * @param {string} [props.className] - Extra class(es) on the block wrapper
 * @param {React.ReactNode} props.children - Section content
 */
const TocDetailSection = ({ label, className = "", children }) => (
  <section className={`tocnav-block${className ? ` ${className}` : ""}`}>
    <h3 className="tocnav-block-label">{label}</h3>
    {children}
  </section>
);

export default TocDetailSection;
